import * as types from '../mutation-types'
import {register,addConversation,queryConversation,offlineMessages,queryOneConversation,findMessages,updateStatus,deleteOfflineMessages} from '@/common/im/api'
import {latestMessageString} from '@/common/im/util'
import { Message } from 'element-ui';

const state = {
  userInfo: {},
  currentUserID: '',
  conversationID: '',
  conversationStatus: 0,
  audioMessageID: '',
  messageList: {},
  conversationList: [],
  currentConversation: {},
};

const getters = {
  tool_show: state => state.conversationID,
  chat_messages: state => {
    if (state.conversationID) {
      if (!state.messageList[state.conversationID]) {
        state.messageList[state.conversationID] = [];
      }
      return state.messageList[state.conversationID];
    }else {
      return [];
    }
  }
};

const mutations = {
  [types.SET_USERID](state,userID) {
    state.currentUserID = userID;
  },
  [types.SET_USER_INFO](state,info) {
    state.userInfo = info;
  },
  [types.SET_CURRENT_CONVERSATION](state,conversation) {
    state.currentConversation = conversation;
  },
  [types.SET_CONVERSATION_STATUS](state,conversation) {

    let user_status = conversation.isCreator ? conversation.user_status : conversation.other_status;
    let other_status = conversation.isCreator ? conversation.other_status : conversation.user_status;

    let status;

    if (user_status === 0 && other_status === 0) {
      status = 0;
    }else if (user_status === 1 && other_status === 0) {
      status = 1;
    }else if (user_status === 0 && other_status === 1) {
      status = 2;
    }else if (user_status === 1 && other_status === 1) {
      status = 3;
    }

    state.conversationStatus = status;
  },
  [types.UPDATE_CONVERSATION_STATUS](state,conversationID) {

    const index = state.conversationList.findIndex((item) => {
      return item.conversation_id === conversationID
    });
    let tempList = Object.assign([], state.conversationList);
    if (index !== -1) {
      let conversation = tempList[index];
      if (conversation.isCreator) {
        conversation.user_status = 1;
      }else{
        conversation.other_status = 1;
      }
    }
    state.conversationList = tempList;
  },
  [types.UPDATE_CONVERSATION_STATUS_OTHER](state,param) {

    const index = state.conversationList.findIndex((item) => {
      return item.conversation_id === param.conversation_id
    });
    let tempList = Object.assign([], state.conversationList);
    if (index !== -1) {
      let conversation = tempList[index];
      if (conversation.isCreator) {
        conversation.other_status = param.status;
      }else{
        conversation.user_status = param.status;
      }
    }
    state.conversationList = tempList;
  },
  [types.SET_CONVERSATION_LIST](state,list) {
    state.conversationList = list;
  },
  [types.SET_AUDIO_MESSAGEID](state,msg_id) {
    state.audioMessageID = msg_id;
  },
  [types.SET_CONVERSATION_USERID](state,conversationID) {
    state.conversationID = conversationID;

    const index = state.conversationList.findIndex((item) => {
      return item.conversation_id === conversationID
    });
    let tempList = Object.assign([], state.conversationList);
    if (index !== -1) {
      tempList[index].unread = 0;
    }
    state.conversationList = tempList;
  },
  [types.ADD_CONVERSATION](state,conversation) {
    state.conversationList.unshift(conversation);
  },
  [types.SEND_CHAT_MESSAGE](state,message) {

    let tempList = Object.assign({}, state.messageList);

    if (!tempList[message.conversation_id]) {
      tempList[message.conversation_id] = [];
    }
    tempList[message.conversation_id].push(message);
    state.messageList = tempList;
  },
  [types.ADD_HISTORY_MESSAGES](state,list) {

    let tempList = Object.assign({}, state.messageList);

    if (!tempList[state.conversationID]) {
      tempList[state.conversationID] = [];
    }

    tempList[state.conversationID] = list.concat(tempList[state.conversationID]);

    state.messageList = tempList;
  },
  [types.UPDATE_CHAT_MESSAGE](state,data) {
    let conversationID = data.conversation_id;
    let list = state.messageList[conversationID];
    const index = list.findIndex((item) => {
      return item.sendtime === data.sendtime
    });

    if (index !== -1) {
      list[index] = data;
    }
  },
  [types.UPDATE_LATEST_MESSAGE](state,message) {

    let latestMsgStr = latestMessageString(message);

    if (state.conversationID === message.conversation_id) {
      const index = state.conversationList.findIndex((item) => {
        return item.conversation_id === message.conversation_id
      });
      (state.conversationList)[index].latestMsgStr = latestMsgStr;
      (state.conversationList)[index].latestMsgTimeStamp = message.timestamp;
    }else {
      const index = state.conversationList.findIndex((item) => {
        return item.conversation_id === message.conversation_id
      });

      if (index !== -1) {
        let conversation = state.conversationList[index];

        let tempObj = Object.assign({}, conversation);
        tempObj.unread = conversation.unread+1;
        tempObj.latestMsgStr = latestMsgStr;
        tempObj.latestMsgTimeStamp = message.timestamp;

        state.conversationList.splice(index, 1);
        state.conversationList.unshift(tempObj);
      }
    }
  },
};

const actions = {
  async loadChatData ({ dispatch, commit },userID) {
    try{
      await dispatch('queryConversation',userID);

      const res = await offlineMessages({
        user_id: userID,
      });
      console.log(res);
      if (res.code === 200) {
        let list = res.data.list;
        list.forEach(function(value,index,array) {

          commit(types.UPDATE_LATEST_MESSAGE, value);
          commit(types.SEND_CHAT_MESSAGE, value);

          dispatch('deleteMessages',userID);
        });
      } else {
        Message.error(res.message);
      }

    }catch(err){

    }
  },
  async deleteMessages ({ commit },userID) {
    try{
      const res = await deleteOfflineMessages({
        user_id: userID,
      });
      if (res.code === 200) {

      } else {
        Message.error(res.message);
      }

    }catch(err){

    }
  },
  async registerUser ({ commit },param) {
    try{
      const res = await register(param);
      if (res.code === 200) {

      } else {
        Message.error(res.message);
      }
    }catch(err){

    }
  },
  async queryConversation ({commit},userID) {
    try{
      const res = await queryConversation({
        user_id: userID,
      });
      console.log(res);
      if (res.code === 200) {
        let list = res.data.list;
        let conversationList = [];
        list.forEach(function(value,index,array) {
          let obj = {};
          obj.conversation_id = value.conversation_id;
          obj.isCreator = value.user_id === userID;
          obj.uid = obj.isCreator ? value.other_id : value.user_id;
          obj.unread = value.unread;
          obj.user_status = value.user_status;
          obj.other_status = value.other_status;
          obj.limit_num = value.limit_num;

          if (value.latest_msg.length) {
            let message = value.latest_msg[0];
            obj.latestMsgTimeStamp = message.timestamp;
            obj.latestMsgStr = latestMessageString(message);
          }
          if (value.user_info) {
            obj.name = value.user_info.name;
            obj.headImage = value.user_info.headImage;
          }
          conversationList.push(obj);
        });
        commit(types.SET_CONVERSATION_LIST, conversationList);
        return Promise.resolve();
      } else {
        Message.error(res.message);
        return Promise.reject();
      }
    }catch(err){
      Message.error('会话查询失败');
      return Promise.reject();
    }
  },
  sendChatMessage ({commit}, message) {
    commit(types.SEND_CHAT_MESSAGE, message);
    commit(types.UPDATE_LATEST_MESSAGE, message);
  },
  async receiveChatMessage ({commit},message) {
    let content = message.msg_content;
    if (content.fileData) {
      content.fileData = '';
    }
    const index = state.conversationList.findIndex((item) => {
      return item.conversation_id === message.conversation_id
    });

    if (index !== -1) {
      commit(types.SEND_CHAT_MESSAGE, message);
      commit(types.UPDATE_LATEST_MESSAGE, message);
    }else {

      try{
        let uid = message.sender_uid === state.currentUserID ? message.receiver_uid : message.sender_uid;
        const res = await queryOneConversation({
          user_id: uid,
          conversation_id: message.conversation_id
        });
        console.log(res);
        if (res.code === 200) {
          let list = res.data.list;
          let value = list[0];

          let obj = {};
          obj.conversation_id = value.conversation_id;
          obj.isCreator = value.user_id === state.currentUserID;
          obj.uid = value.isCreator ? value.other_id : value.user_id;
          obj.unread = value.unread;
          obj.user_status = value.user_status;
          obj.other_status = value.other_status;
          obj.limit_num = value.limit_num;

          obj.latestMsgTimeStamp = message.timestamp;
          obj.latestMsgStr = latestMessageString(message);

          if (value.user_info) {
            obj.name = value.user_info.name;
            obj.headImage = value.user_info.headImage;
          }

          obj.unread = state.conversationID===obj.conversation_id?0:1;

          commit(types.ADD_CONVERSATION, obj);
          commit(types.SEND_CHAT_MESSAGE, message);
        } else {
          Message.error(res.message);
        }

      }catch(err){

      }
    }
  },
  async selectConversation ({dispatch,commit},conversation_id) {
    commit(types.SET_CONVERSATION_USERID, conversation_id);

    const index = state.conversationList.findIndex((item) => {
      return item.conversation_id === state.conversationID
    });
    let conversation = index === -1 ? {} : state.conversationList[index];
    commit(types.SET_CURRENT_CONVERSATION, conversation);

    commit(types.SET_CONVERSATION_STATUS, conversation);

    if (!state.messageList[conversation_id]) {
      state.messageList[conversation_id] = [];
    }
    let list = state.messageList[conversation_id];

    if (list.length === 0) {
      let param = {
        conversation_id: conversation_id,
        num: 0,
        size: 10
      };
      dispatch('findMessages',param);
    }

  },
  async findMessages ({commit},param) {
    try{
      const res = await findMessages(param);
      console.log(res);
      if (res.code === 200) {
        commit(types.ADD_HISTORY_MESSAGES, res.data.list);
      } else {
        Message.error(res.message);
      }
    }catch(err){

    }
  },
  async updateConversationStatus ({commit},param) {
    try{
      const res = await updateStatus(param);
      console.log(res);
      if (res.code === 200) {
        commit(types.UPDATE_CONVERSATION_STATUS, state.conversation_id);

        commit(types.SET_CONVERSATION_STATUS, state.currentConversation);
      } else {
        Message.error(res.message);
      }
    }catch(err){

    }
  },
  updateOtherConversationStatus ({commit},param) {

    commit(types.UPDATE_CONVERSATION_STATUS_OTHER, param);

    commit(types.SET_CONVERSATION_STATUS, state.currentConversation);

  },
  async startConversation ({commit},uid) {
    try{
      let parameters = {
        user_id: state.currentUserID,
        other_id: uid,
        info: {}
      };
      const res = await addConversation(parameters);
      console.log(res);
      if (res.code === 200) {

        let conversationId = res.data.conversation_id;

        const index = state.conversationList.findIndex((item) => {
          return item.conversation_id === conversationId
        });

        if (index === -1) {

          let param = {
            user_id: uid,
            conversation_id: conversationId,
          };

          const res = await queryOneConversation(param);
          console.log(res);
          if (res.code === 200) {
            let list = res.data.list;
            let value = list[0];

            let obj = {};
            obj.conversation_id = value.conversation_id;
            obj.isCreator = value.user_id === state.currentUserID;
            obj.uid = value.isCreator ? value.other_id : value.user_id;
            obj.unread = value.unread;
            obj.user_status = value.user_status;
            obj.other_status = value.other_status;
            obj.limit_num = value.limit_num;

            if (value.user_info) {
              obj.name = value.user_info.name;
              obj.headImage = value.user_info.headImage;
            }

            commit(types.ADD_CONVERSATION, obj);

          } else {
            Message.error(res.message);
          }

        }else {

        }

      } else {
        Message.error(res.message);
      }
    }catch(err){

    }
  }

};


export default {
  state,
  getters,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/conversation.js